module.exports = __webpack_public_path__ + "static/media/bank4.795489f7.png";